import React , {
  useState,
} from 'react';
import Header from '../../layout/header/header';
import Sidebar from '../../layout/sidebar/sidebar';
import OrderC from '../../layout/center/order';
function Order(props) {
  const [searchOrder, setSearchOrder] = useState(''); 

  const handleSearch = (term) => {
    setSearchOrder(term);
  };
    return (
        <div className='container' >
        <Header placeholder={'Search order by place, braid or status'} isHomePage={false} onSearch={handleSearch}/>
        <Sidebar/>
        <OrderC  searchOrder={searchOrder}/>
      </div>
    );
}

export default Order;